import React from 'react';

import { Image, Stack } from 'grommet';

const Logo = () => (
  <Stack anchor='center'>
      <Image width='50' src='/logo.png' />
  </Stack>
);

export { Logo };
